module.exports = __webpack_public_path__ + "img/HeroTypesQuiz-Q2.0cefd3c3.png";